import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as MenuIcon } from "../images/icons/MenuIcon.svg";
import { ReactComponent as CloseIcon } from "../images/icons/CloseIcon.svg";
import purpleCurvedLine from "../images/svgPaths/purpleCurvedLine.svg";

export default function Header() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [navigate]);

  return (
    <>
      <header className="sticky -top-0.5 left-0 z-20 bg-black px-6 lg:px-16 py-5 grid grid-cols-12 gap-1 border-b-4 border-black max-w-[100vw]">
        <div className="col-span-12 flex justify-between items-center ">
          <div
            className="justify-self-center order-2 lg:order-1 cursor-pointer transition-all ease-in-out duration-300"
            onClick={() => navigate("/")}
          >
            <img
              src="https://cdn.strabl.com/logo/SVG/180x180_logo1_w.svg"
              width={180}
              height={180}
              alt="Strabl logo"
              className="w-36 h-8 object-cover"
            />
          </div>
          <nav className="order-1 lg:order-2">
            <ul className="w-auto h-auto hidden lg:flex flex-row justify-end items-center gap-5 bg-transparent px-0 pt-0">
              <li
                className="block lg:hidden text-sm font-gtAmericaMedium leading-tight cursor-pointer text-white z-[1] lg:z-auto"
                onClick={() => {
                  navigate("/");
                }}
              >
                Home
              </li>
              <li
                className="text-sm font-gtAmericaMedium leading-tight cursor-pointer text-white z-[1] lg:z-auto"
                onClick={() => {
                  navigate("/how-it-works-for-shoppers");
                }}
              >
                For Shoppers
              </li>
              {/* <li
                className="text-sm font-gtAmericaMedium leading-tight cursor-pointer text-white z-[1] lg:z-auto"
                onClick={() => {
                  navigate("/pricing");
                }}
              >
                Pricing
              </li> */}
              <li
                className="text-sm font-gtAmericaMedium leading-normal cursor-pointer rounded px-4 pb-2.5 pt-2.5 bg-white text-black uppercase z-[1] lg:z-auto"
                onClick={() => {
                  navigate("/get-in-touch");
                }}
              >
                Get in touch
              </li>
              <li
                className="text-sm font-gtAmericaMedium leading-normal cursor-pointer rounded px-4 pb-2.5 pt-2.5 bg-[#9B03D0] text-white uppercase z-[1] lg:z-auto"
                onClick={() => {
                  window.open("https://dashboard.strabl.io", "_blank");
                }}
              >
                MERCHANT LOGIN
              </li>
            </ul>

            <MenuIcon
              className={`text-4xl block lg:hidden cursor-pointer text-white border-2 border-black ${
                isMenuOpen ? "opacity-0" : "opacity-100"
              }`}
              onClick={() => setIsMenuOpen(true)}
            />
          </nav>
          <div className="order-3 block lg:hidden">
            <CloseIcon
              className={`text-4xl text-white ${
                !isMenuOpen ? "opacity-0" : "opacity-100"
              }`}
              onClick={() => setIsMenuOpen(false)}
            />
          </div>
        </div>
      </header>

      {/* Nav DropDown for Mobile & Tablet  */}
      <section
        className={`w-screen h-screen fixed top-0 left-0 pt-7 pb-16 px-8 sm:px-14 flex lg:hidden flex-col gap-y-7 bg-black z-[20] transition-all ease-in-out duration-300 ${
          isMenuOpen ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <section className="flex items-center justify-between  z-[1]">
          <div
            className="justify-self-center cursor-pointer transition-all ease-in-out duration-300 w-fit"
            onClick={() => navigate("/")}
          >
            <img
              src="https://cdn.strabl.com/logo/SVG/180x180_logo1_w.svg"
              width={180}
              height={180}
              alt="Strabl logo"
              className="w-36 sm:w-56 h-11 object-cover -ml-1"
            />
          </div>
          <CloseIcon
            className={`text-4xl text-white ${
              !isMenuOpen ? "opacity-0" : "opacity-100"
            }`}
            onClick={() => setIsMenuOpen(false)}
          />
        </section>
        <ul className="list-none flex flex-col gap-y-7">
          <li
            className="mt-0 sm:mt-5 text-2xl sm:text-[26px] font-gtAmericaMedium leading-tight cursor-pointer text-white list-none z-[1]"
            onClick={() => {
              navigate("/");
              setIsMenuOpen(false);
            }}
          >
            Home
          </li>
          <li
            className="text-2xl sm:text-[26px] font-gtAmericaMedium leading-tight cursor-pointer text-white list-none z-[1]"
            onClick={() => {
              navigate("/how-it-works-for-shoppers");
              setIsMenuOpen(false);
            }}
          >
            For Shoppers
          </li>
          {/* <li
          className="text-2xl sm:text-[26px] font-gtAmericaMedium leading-tight cursor-pointer text-white list-none z-[1]"
          onClick={() => {
            navigate("/pricing");
            setIsMenuOpen(false);
          }}
        >
          Pricing
        </li> */}
          <li
            className="text-2xl sm:text-[26px] font-gtAmericaMedium leading-tight cursor-pointer text-white list-none z-[1]"
            onClick={() => {
              navigate("/get-in-touch");
              setIsMenuOpen(false);
            }}
          >
            Get In Touch
          </li>
        </ul>
        <ul className="mt-auto flex flex-col gap-y-4 z-[1]">
          <li
            className="text-lg sm:text-xl font-gtAmericaMedium leading-tight cursor-pointer text-white list-none"
            onClick={() => {
              window.open("https://dashboard.strabl.io", "_blank");
              setIsMenuOpen(false);
            }}
          >
            Login as Merchant
          </li>
          <li
            className=" text-lg sm:text-xl font-gtAmericaMedium leading-tight cursor-pointer text-white list-none"
            onClick={() => {
              window.open("https://dashboard.strabl.io", "_blank");
              setIsMenuOpen(false);
            }}
          >
            Login as Customer
          </li>
        </ul>

        <img
          src={purpleCurvedLine}
          alt="Purple curved line"
          className="absolute bottom-44 sm:bottom-10 left-0 block md:hidden w-full rotate-0 sm:rotate-12 z-0 "
          width={744}
          height={697}
        />
      </section>
    </>
  );
}
